define(['jquery'], function categoryFilter($) {
    "use strict";

    var $body = $(window.document.body),
        category,
        internalAPI;

    var bind = function bind(API) {
        category = require('category');
        internalAPI = API;

    };

    bind = function bind() {
        var _onLiExpandClick,
            _onLiAClick;

        _onLiExpandClick = function _onLiExpandClick() {
            $(this).closest('li').toggleClass('expanded');
            return false;
        };

        _onLiAClick = function _onLiAClick() {
            var $a = $(this),
                $leaf = $a.parent('.leaf'),
                $li = $leaf.parent('li'),
                $tree = $li.closest('.categories-filter'),
                $siblings = $li.siblings();

            $tree.find('li').removeClass('active');
            $siblings.removeClass('expanded');
            $li.addClass('active expanded');
            return false;
        };

        $body.on('click', '.categories-filter li > .leaf > .expand', _onLiExpandClick);
        $body.on('click', '.categories-filter li > .leaf > a', _onLiAClick);

    };

    return {
        bind: bind
    };

});